<template>
    <div id="countdown-banner">
        <div class="d-flex justify-content-between align-items-center title-block border-bottom ml-3 ">
            <PageTitleComponent pageTitle="Countdown Banner" category="Werbeinhalte" categoryIcon="ad" />
            <button class="btn btn-primary" v-b-modal="'create-banner-modal'" v-if="bannerDetails">
                Banner bearbeiten
            </button>
            <button class="btn btn-primary" v-b-modal="'create-banner-modal'" v-else>
                <fa-icon :icon="['fas', 'plus']" class="mr-2" />Banner erstellen
            </button>
        </div>
        <div class="py-3 p-3">
            <ObtainCurrentBannerComponent />
            <b-modal size="lg" id="create-banner-modal" ref="create-banner-modal" title="Banner erstellen"
                no-close-on-backdrop hide-header-close content-class="shadow" scrollable>

                <label for="name" class="font-weight-bold">Name des Banners</label>
                <b-form-input id="name" v-model="bannerName" class="form-group"
                    placeholder="Aktionbanner"></b-form-input>

                <label for="link" class="font-weight-bold">Shops</label>
                <p class="small">Mehrfachauswahl: CMD + Klick</p>
                <b-form-select v-model="selectedShops" :options="shops" multiple :select-size="3"></b-form-select>

                <div class="d-flex align-items-center mt-3">
                    <b-form-checkbox id="bannerEnabled" v-model="bannerEnabled" name="bannerEnabled">
                        <p v-if="bannerEnabled">
                            Banner <span class="font-weight-bold">aktiv </span> und sichtbar im Shop.
                        </p>
                        <p v-else>
                            Banner aktivieren
                        </p>
                    </b-form-checkbox>
                </div>

                <p class="font-weight-bold">Link</p>
                <LinkComponent v-on:linkChanged="linkChanged" :linkProp="propsForLinkComponent" />

                <label class="font-weight-bold" for="Schriftfarbe">Schriftfarbe
                    auswählen</label>
                <div class="d-flex align-items-center mb-2">
                    <b-form-input class="w-25" id="Schriftfarbe" v-model="textColor" type="color"></b-form-input>
                    <p class="ml-3">
                        Ausgewählte Farbe (HEX-Wert): <span class="font-weight-bold">{{ textColor }}</span>
                    </p>
                </div>
                <label class="font-weight-bold " for="labelfarbe">Labelfarbe
                    auswählen</label>
                <div class="d-flex align-items-center  mb-2 ">
                    <b-form-input class="w-25" id="labelfarbe" v-model="labelColor" type="color"></b-form-input>
                    <p class="ml-3">
                        Ausgewählte Farbe (HEX-Wert): <span class="font-weight-bold">{{ labelColor }}</span>
                    </p>
                </div>

                <label class="font-weight-bold  mb-2">Anzeigezeitraum</label>
                <b-form-group label-cols-sm="1" label="Bis" label-for="datepicker-to-date">
                    <b-form-datepicker id="datepicker-to-date" v-model="endDate" :locale="'de-DE'"></b-form-datepicker>
                </b-form-group>
                <label class="font-weight-bold">Uhrzeit</label>
                <b-form-group label-cols-sm="1" label="Bis" label-for="to-time">
                    <b-form-timepicker id="to-time" v-model="toTime" :locale="'de'"></b-form-timepicker>
                </b-form-group>

                <label class="font-weight-bold">Bild</label>
                <table class="mb-3 text-muted" cellpadding="2">
                    <tbody>
                        <tr>
                            <td>Bildgröße (px):</td>
                            <td>846 × 288</td>
                        </tr>
                        <tr>
                            <td>Erlaubte Dateiformate</td>
                            <td>jpg, png</td>
                        </tr>
                    </tbody>
                </table>
                <div class="w-100  mb-2">
                    <p>Banner in <span class="font-weight-bold">deutscher</span> Version hochladen</p>
                    <UploadImageComponent v-on:imageUpload="imageUploadDe" :imageProp="this.imgSrc_de" />
                </div>
                <div class="w-100  mb-2">
                    <p>Banner in <span class="font-weight-bold">Englischer</span> Version hochladen</p>
                    <UploadImageComponent v-on:imageUpload="imageUploadedEn" :imageProp="this.imgSrc_en" />
                </div>

                <template v-slot:modal-footer>
                    <b-button variant="outline-secondary" v-on:click="hideModal">Abbrechen</b-button>
                    <SaveButtonComponent :saveButtonSate="saveButtonSate" v-on:submitSaveButton="saveChanges" />
                </template>
            </b-modal>

        </div>
    </div>
</template>
<script>
import PageTitleComponent from '../components/PageTitleComponent.vue';
import SaveButtonComponent from "../components/SaveButtonComponent.vue";
import UploadImageComponent from '../components/UploadImageComponent.vue';
import LinkComponent from '../components/LinkComponent.vue';
import ObtainCurrentBannerComponent from '../components/ObtainCurrentBannerComponent.vue';
import { ref, set, onValue } from "firebase/database";
import { db } from "../plugins/firebase";
import { store } from '../plugins/store';

export default {
    name: "CountdownBannerView",
    components: {
        PageTitleComponent,
        LinkComponent,
        UploadImageComponent,
        SaveButtonComponent,
        ObtainCurrentBannerComponent
    },
    data() {
        return {
            bannerDetails: {},
            saveButtonSate: '',
            endDate: null,
            toTime: "12:30:00",
            fullDate: null,
            bannerName: "",
            imgSrc_de: "",
            imgSrc_en: "",
            textColor: "#000000",
            labelColor: "#000000",
            bannerEnabled: false,
            selectedShops: [],
            link: {
                target: "_blank",
                url: "",
                intValue: "",
                body: "",
                subject: "",
                type: "Extern",
            },
            shops: [
                {
                    text: 'Standard',
                    value: 'standard'
                },
            ],
            propsForLinkComponent: {
                limitedShops: "limitTheSelectOption",
            }

        }
    },
    methods: {
        imageUploadDe: function (image) {
            this.imgSrc_de = image.url
        },
        imageUploadedEn: function (image) {
            this.imgSrc_en = image.url
        },
        linkChanged: function (data) {
            this.link = data
        },
        saveChanges: function () {
            if (
                this.bannerName === "" ||
                this.imgSrc_de === "" ||
                this.imgSrc_en === "" ||
                this.selectedShops.length === 0 ||
                this.toTime === '' ||
                this.endDate === null
            ) {
                store.dispatch("fetchAlert", {
                    kind: 'danger',
                    message: "Eingabe unvollständig. Bitte die Eingabe-Felder überprüfen!",
                    time: false
                })
                return;
            }
            this.saveButtonSate = "saving";
            console.log(typeof this.endDate, this.endDate)
            const date = typeof this.endDate === 'object' ? this.endDate.toLocaleDateString("de-DE", { year: "numeric", month: "2-digit", day: "2-digit" }).split(".").reverse().join("-") : this.endDate;

            console.log("date", date)

            const time = this.toTime;
            this.fullDate = new Date(date + "T" + time).getTime();
            const document = {
                link: {
                    target: this.link.target,
                    url: this.link.url ? this.link.url : null,
                },
                endDate: this.fullDate,
                name: this.bannerName,
                imgSrc_de: this.imgSrc_de,
                imgSrc_en: this.imgSrc_en,
                textColor: this.textColor,
                labelColor: this.labelColor,
                bannerEnabled: this.bannerEnabled,
                selectedShops: this.selectedShops,
            };
            set(ref(db, "countdownBanner"), document)
                .then(() => {
                    this.saveButtonSate = "done";
                    setTimeout(() => this.hideModal(), 1800);
                })
                .catch((error) => {
                    this.saveButtonSate = "error";
                    console.error(error);
                    store.dispatch("fetchAlert", {
                        kind: "danger",
                        message: error,
                        time: false,
                    });
                    setTimeout(() => (this.saveButtonSate = ""), 1800);
                });
        },
        hideModal: function () {
            this.$refs['create-banner-modal'].hide()
        },
    },
    mounted() {
        this.$root.$on('bv::modal::hidden', () => {
            this.saveButtonSate = "";
        })
        onValue(ref(db, "countdownBanner"), (snapshot) => {
            this.bannerDetails = snapshot.val();

            if (this.bannerDetails) {
                this.bannerName = this.bannerDetails.name;

                this.propsForLinkComponent = {
                    limitedShops: "limitTheSelectOption",
                    url: this.bannerDetails.link.url,
                    target: this.bannerDetails.link.target
                }

                this.imgSrc_de = this.bannerDetails.imgSrc_de;

                this.imgSrc_en = this.bannerDetails.imgSrc_en;

                this.selectedShops = this.bannerDetails.selectedShops;

                this.endDate = new Date(this.bannerDetails.endDate);

                this.toTime = new Date(this.bannerDetails.endDate).toLocaleTimeString("de-DE");

                this.textColor = this.bannerDetails.textColor;

                this.labelColor = this.bannerDetails.labelColor;

                this.bannerEnabled = this.bannerDetails.bannerEnabled;
            }
        });
    },
}
</script>
<style scoped>
#countdown-banner {
    margin-left: 250px;
}

.title-block {
    height: 120px;
}

.bannerImg {
    width: 846px;
    min-height: 200px;
    border: 0.01px dashed;
}
</style>